var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.9756C13.6569 12.9756 15 11.6324 15 9.97559C15 8.31873 13.6569 6.97559 12 6.97559C10.3431 6.97559 9 8.31873 9 9.97559C9 11.6324 10.3431 12.9756 12 12.9756Z",
    stroke: "#051B46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 9.97559C19.5 16.7256 12 21.9756 12 21.9756C12 21.9756 4.5 16.7256 4.5 9.97559C4.5 7.98646 5.29018 6.07881 6.6967 4.67229C8.10322 3.26576 10.0109 2.47559 12 2.47559C13.9891 2.47559 15.8968 3.26576 17.3033 4.67229C18.7098 6.07881 19.5 7.98646 19.5 9.97559Z",
    stroke: "#051B46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.c4a647ad36fc2b4b184efe53c9be77f1.svg";
export { ForwardRef as ReactComponent };